// Immagini ospitate nelle Risorse Impultienda del negozio SISTEMA ENERGETICO TAROCCHI · REIKI · CHAKRA™ (T-R-C IT).
const R = 'https://sb.impultienda.ar/storage/v1/object/public/store-resources/f9391cce-20f5-4c7e-9a56-02eaa79ab072/'

export const CHECKOUT_URL = 'https://negozio-energetico.eurekalabs.store/checkout'

export const images = {
  // Mockup libro + 5 schede a ventaglio su fondo bianco (stile del mockup approvato dal proprietario).
  mockup: R + '1793750666382_carta-mockup-520c8e42.jpg',
  // Scene 2048×1360: libro illustrato + libro aperto su un tavolo (stessa linea della pagina Reiki FR).
  volumes: [
    R + '1793750671980_carta-vol-1-scene-73bc775b.jpg',
    R + '1793750677980_carta-vol-2-scene-2d7226ce.jpg',
    R + '1793750684248_carta-vol-3-scene-f88cb2d4.jpg',
    R + '1793750690460_carta-vol-4-scene-e1536556.jpg',
    R + '1793750696667_carta-vol-5-scene-65d5981b.jpg',
    R + '1793750703324_carta-vol-6-scene-8cd1356c.jpg',
  ],
  volumePages: [
    { src: R + '1793751155292_carta-vol1-p07-d1d747bc.jpg', alt: 'Volume 1: tre pratiche a colpo d’occhio' },
    { src: R + '1793751160814_carta-vol1-p18-5d7bb140.jpg', alt: 'Volume 1: la tua prima stesa a 3 carte' },
    { src: R + '1793751166807_carta-vol1-p25-2f497e7f.jpg', alt: 'Volume 1: l’autotrattamento in 12 posizioni' },
    { src: R + '1793751173075_carta-vol1-p34-c7b3a724.jpg', alt: 'Volume 1: la seduta integrata in 75 minuti' },
  ],
  printables: [
    { src: R + '1793751120271_carta-scheda-09-cea86c1f.jpg', label: '#09 · Arcani Maggiori, dal Matto alla Ruota' },
    { src: R + '1793751126322_carta-scheda-17-192f032b.jpg', label: '#17 · La stesa a 3 carte' },
    { src: R + '1793751132208_carta-scheda-25-ae2682b9.jpg', label: '#25 · Mappa dell’autotrattamento' },
    { src: R + '1793751138224_carta-scheda-33-5e90e41a.jpg', label: '#33 · I 7 chakra secondo la tradizione' },
    { src: R + '1793751143789_carta-scheda-46-396c5263.jpg', label: '#46 · Tavola sì · no · forse' },
    { src: R + '1793751149311_carta-scheda-51-51d9c907.jpg', label: '#51 · La seduta integrata, 75 minuti' },
  ],
  // Schede bonus 1600×1280: scena + fascia con titolo, 4 icone e 15 € → 0 € (stesso modello di Reiki FR).
  bonuses: [
    R + '1793751091020_carta-bonus-1-3e0dc0d5.jpg',
    R + '1793751097314_carta-bonus-2-b16f88be.jpg',
    R + '1793751103692_carta-bonus-3-ff358750.jpg',
    R + '1793751109531_carta-bonus-4-6f44c85e.jpg',
    R + '1793751115434_carta-bonus-5-a5fca76f.jpg',
  ],
}
